import clsx from 'clsx';
import { format } from 'date-fns';
import { useState } from 'react';
import { default as ReactDatePicker } from 'react-datepicker';

import '../../.././../node_modules/react-datepicker/dist/react-datepicker.css';

export type DatePickerProps = {
  name?: string;
  defaultValue?: string;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  placeHolder?: string;
  onChange?: (value: string) => void;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  className?: string;
  useFormElementWrapper?: boolean;
};

export function DatePicker({
  name,
  defaultValue,
  dateFormat,
  minDate,
  maxDate,
  placeHolder,
  onChange,
  disabled,
  required,
  className,
  useFormElementWrapper = true,
}: DatePickerProps) {
  const [startDate, setStartDate] = useState(
    defaultValue !== undefined && defaultValue !== null && defaultValue !== '' ? new Date(defaultValue) : null,
  );

  const handleChange = (date: Date) => {
    const dateStr = date
      ? format(date, dateFormat ?? 'yyyy-MM-dd', {
          useAdditionalWeekYearTokens: true,
          useAdditionalDayOfYearTokens: true,
        })
      : '';
    setStartDate(date);
    onChange?.(dateStr);
  };

  const datePicker = (
    <ReactDatePicker
      name={name}
      dateFormat={dateFormat ?? 'yyyy-MM-dd'}
      selected={startDate}
      onChange={handleChange}
      placeholderText={placeHolder}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      required={required}
      className={clsx('o-input', className)}
    />
  );

  return useFormElementWrapper ? <div className="c-form-element">{datePicker}</div> : datePicker;
}

export default DatePicker;
